module.exports = __webpack_public_path__ + "img/Emm.4066db14.png";